<template>
  <div class="side_box">
    <div>
      <label for="lotnumber">Production order</label>
      <span v-if="this.item">{{this.item.bonID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">REF number</label>
      <span v-if="this.item">{{this.item.ref}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">Part ID</label>
      <span v-if="this.item">{{this.item.bonPartID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="subparts">Raw material</label>
      <span v-if="this.item">{{this.item.rawMaterialID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Description</label>
      <span v-if="this.item">{{this.item.description}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Comment</label>
      <span v-if="this.item">{{this.item.comment}}</span>
      <span v-else>...</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
  },
  props: {
    item: Object
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}
</style>
